import React from "react";
import styled from "styled-components";
import Icon from "@material-ui/core/Icon";
import PropTypes from "prop-types";

const HeaderContainer = styled.div`
  display: flex;
`;

const ContentWrap = styled.div`
  background: ${(props) => (props.alternateColor ? "#f0f4fc" : "#FFFFFF")};
  border-top-right-radius: ${(props) => (props.roundTop ? "8px" : "0")};
  border-top-left-radius: ${(props) => (props.roundTop ? "8px" : "0")};
  border-bottom-right-radius: ${(props) => (props.roundBottom ? "8px" : "0")};
  border-bottom-left-radius: ${(props) => (props.roundBottom ? "8px" : "0")};
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
`;

const SettingHeader = styled.div`
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 70px;
  width: 100%;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const SettingName = styled.p`
  color: #2b3c4d;
  font-size: 1.125rem;
  font-weight: 600;
  margin-left: 36px;
  @media (max-width: 900px) {
    font-size: 1rem;
    margin-left: 16px;
  }
`;

const SettingCurrent = styled.p`
  color: #516375;
  font-size: 1rem;
  font-weight: 500;
  margin-right: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 900px) {
    display: none;
  }
  span {
    color: #2b3c4d;
    font-size: 2rem;
    margin-left: 20px;
    transition: transform 0.3s ease;
    transform: ${(props) => (props.open ? "rotateZ(180deg)" : "rotateZ(0deg)")};
  }
`;

const SettingContent = styled.div`
  overflow: hidden;
  transition: all .3s ease-in-out;
  max-height: ${(props) => (props.open ? "1400px" : "0px")};
`;

const Description = styled.h6`
  color: #516375;
  font-size: 1.125rem;
  font-weight: 400;
  margin-bottom: 15px;
  @media (max-width: 900px) {
    font-size: .8rem !important;
  }
`;

const ChildrenContainer = styled.div`
  padding: 0px 36px 36px 36px;

  p {
    color: #516375;
    font-size: 1.125rem;
    margin-bottom: 14px;
    @media (max-width: 900px) {
      font-size: .8rem;
    }
  }

  h5 {
    font-size: 1.25rem;
    @media (max-width: 900px) {
      font-size: .9rem;
    }
  }

  @media (max-width: 900px) {
    padding: 0px 16px 16px 16px;
  }
`;

export const Accordion = (props) => {
  return (
    <HeaderContainer>
      <ContentWrap
        roundTop={props.roundTop}
        roundBottom={props.roundBottom}
        alternateColor={props.alternateColor}
      >
        <SettingHeader
          onClick={() => {
            props.setShow(!props.show);
          }}
        >
          <HeaderContent>
            <SettingName>{props.settingName}</SettingName>
            <SettingCurrent open={props.show}>
              {props.currentSetting} <Icon>keyboard_arrow_down</Icon>
            </SettingCurrent>
          </HeaderContent>
        </SettingHeader>
        <SettingContent open={props.show}>
          <ChildrenContainer>
            <Description>{props.description}</Description>
            {props.children}
          </ChildrenContainer>
        </SettingContent>
      </ContentWrap>
    </HeaderContainer>
  );
};

Accordion.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  alternateColor: PropTypes.bool,
  roundTop: PropTypes.bool,
  roundBottom: PropTypes.bool,
  settingName: PropTypes.string,
  currentSetting: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.element.isRequired,
};
